import { isNullish } from 'utils/nullish';
import cloneDeep from 'lodash/lang/cloneDeep';
import {
  FieldCategory,
  FieldNameToFieldInfo,
  LogicalOperator,
  QueryType,
} from 'components/commons/IssueCrashFilter/IssueCrashFilterExUtil';
import { ze } from 'utils/zhEn';

export const SearchConditionGroupUtil = Object.freeze({
  /** 为scg添加一条必须满足的condition，返回新的scg */
  addMustCondition(searchConditionGroup, condition) {
    if (isNullish(searchConditionGroup) || isNullish(condition)) {
      return searchConditionGroup;
    }
    let res = cloneDeep(searchConditionGroup);
    // 如果searchConditionGroup的逻辑关系是OR，那么要把当前的group变成子group套在AND里面
    if (searchConditionGroup.operator === LogicalOperator.OR) {
      const subgroup = res;
      res = {
        operator: LogicalOperator.AND,
        conditions: [],
        subgroups: [subgroup],
      };
    }
    if (isNullish(res.conditions)) {
      res.conditions = [];
    }
    res.conditions.push(condition);
    return res;
  },

  hasCrashExtraCondition(scg) {
    if (isNullish(scg)) {
      return false;
    }
    const {
      conditions,
      subgroups,
    } = scg;

    return !!conditions?.some(cond => {
        const fieldInfo = FieldNameToFieldInfo[cond.field];
        return fieldInfo?.fieldCategoryList?.includes(FieldCategory.CRASH_EXTRA);
      })
      || !!subgroups?.some(subgroup => SearchConditionGroupUtil.hasCrashExtraCondition(subgroup));
  },

  /** 深度过滤scg中满足predicate条件的condition，返回所有满足条件的condition数组 */
  filterDeep(scg, predicate) {
    if (isNullish(scg)) {
      return [];
    }

    const res = [];

    // Filter shallow conditions at current level
    const conditions = scg.conditions;
    if (!isNullish(conditions) && Array.isArray(conditions)) {
      conditions.forEach(cond => {
        if (!isNullish(cond) && predicate(cond)) {
          res.push(cond);
        }
      });
    }

    // Recursively filter subgroups
    const subgroups = scg.subgroups;
    if (!isNullish(subgroups) && Array.isArray(subgroups)) {
      subgroups.forEach(subgroup => {
        const subgroupRes = SearchConditionGroupUtil.filterDeep(subgroup, predicate);
        res.push(...subgroupRes);
      });
    }

    return res;
  },

  validateCondition(cond) {
    let errorMsgList = [];
    if (isNullish(cond)) {
      return errorMsgList;
    }
    if (cond.queryType === QueryType.TERM_REGEXP_MATCH && !!cond.term) {
      try {
        new RegExp(cond.term);
      } catch (e) {
        const msg = ze(`非法的正则表达式：${e.message}`, `Illegal RegExp: ${e.message}`);
        errorMsgList.push(msg);
      }
    }
    return errorMsgList;
  },

  validateScg(scg) {
    let errorMsgList = [];
    if (isNullish(scg)) {
      return errorMsgList;
    }
    const { conditions, subGroups } = scg;
    if (Array.isArray(conditions)) {
      conditions.forEach(cond => {
        errorMsgList = [...errorMsgList, ...SearchConditionGroupUtil.validateCondition(cond)];
      });
    }
    if (Array.isArray(subGroups)) {
      subGroups.forEach(subgroup => {
        errorMsgList = [...errorMsgList, ...SearchConditionGroupUtil.validateScg(subgroup)];
      });
    }
    return errorMsgList;
  },
});
